export default "__VITE_ASSET__CTIKEx6H__"